import React from 'react';
import {
    Comparison,
    isExactComparison,
    isMembershipComparison,
    isRangeComparison,
} from 'utils/components/FiltersModal/comparison/FilterComparison';

import { EnumMap } from '@instinet-analytics/core-lib';
import ComparisonGroupExact from 'utils/components/FiltersModal/comparison/ComparisonGroupExact';
import ComparisonGroupMembership from 'utils/components/FiltersModal/comparison/ComparisonGroupMembership';
import ComparisonGroupRange from 'utils/components/FiltersModal/comparison/ComparisonGroupRange';

export interface ComparisonGroupProps<TDataItem> {
    columnName?: string;
    fieldName?: string;

    comparison?: Comparison;
    enumMap?: EnumMap;
    data?: TDataItem[];
    staticData?: { [dimension: string]: string[] };
    setComparison?: (comparison: Comparison, commitOnSet?: boolean) => void;
    onInputEnter: () => void;
}

export default function ComparisonGroup<TDataItem>(
    props: ComparisonGroupProps<TDataItem>
) {
    const {
        columnName,
        comparison,
        fieldName,
        setComparison,
        data,
        staticData,
        enumMap,
        onInputEnter,
    } = props;

    if (!comparison || !setComparison) {
        return null;
    }

    if (isExactComparison(comparison)) {
        return (
            <ComparisonGroupExact
                columnName={columnName!}
                comparison={comparison}
                enumMap={enumMap}
                setComparison={setComparison}
                onInputEnter={onInputEnter}
            />
        );
    }

    if (isMembershipComparison(comparison)) {
        return (
            <ComparisonGroupMembership
                columnName={columnName!}
                fieldName={fieldName!}
                comparison={comparison}
                data={data}
                staticData={staticData}
                enumMap={enumMap}
                setComparison={setComparison}
                onInputEnter={onInputEnter}
            />
        );
    }

    if (isRangeComparison(comparison)) {
        return (
            <ComparisonGroupRange
                columnName={columnName!}
                comparison={comparison}
                setComparison={setComparison}
                onInputEnter={onInputEnter}
            />
        );
    }

    return null;
}
